import { render, staticRenderFns } from "./PerformanceMarketingPaymentOptions.vue?vue&type=template&id=473b1fd3"
import script from "./PerformanceMarketingPaymentOptions.vue?vue&type=script&lang=js"
export * from "./PerformanceMarketingPaymentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports